export default __webpack_public_path__ + "static/media/earthrecharge.60d09319.png";